<template>
  <v-app id="app_product_list">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">PRODUCTS LIST</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Analyse orders placed in your store</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">

              <v-btn 
                size="x-large" 
                variant="text" 
                color="#800080"
                @click="addProductsPageRoute()"
              >
                <v-icon color="#800080">mdi-plus-circle</v-icon>&nbsp;&nbsp;ADD PRODUCTS
              </v-btn>

            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8 custom-square-card" elevation="1" border="sm opacity-1">
        <v-card-text class="custom_tool_bar_style">
          <v-btn class=" custom_pdf_btn custom-square-card" variant="outlined" @click="exportPDF">
            <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
          </v-btn>
          <v-btn class="custom_excel_btn ml-4 custom-square-card" variant="outlined" @click="exportExcel">
            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
          </v-btn>
        </v-card-text>

        <v-divider thickness="2"></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete
                  v-model="selectedMainCategory" :clear-icon="selectedMainCategory ? 'mdi-close-circle' : null"
                  :items="mainCategories"
                  clearable item-title="name" item-value="id" label="Main Category" placeholder="Select main category"
                  variant="outlined" class="custom_input_field_color square-border-input"
                  density="comfortable" chips closable-chips 
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                  v-model="selectedSubCategory" :clear-icon="selectedSubCategory.length > 0 ? 'mdi-close-circle' : null"
                  :items="uniqueTableSubCategories"
                  clearable item-title="sub_category_name" item-value="sub_category_name" label="Sub Category"
                  multiple placeholder="Select sub category" variant="outlined" class="custom_input_field_color square-border-input"
                  density="comfortable" chips closable-chips
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field v-model="search" :clear-icon="search ? 'mdi-close-circle' : null" append-inner-icon="mdi-magnify" clearable
                            hide-details label="Search" placeholder="Search Products" variant="outlined"
                            class="custom_input_field_color square-border-input" density="comfortable"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                  v-model="priceFilterMode"
                  :items="priceFilterModes"
                  item-title="title"
                  item-value="value"
                  label="Price Filter"
                  variant="outlined"
                  class="custom_input_field_color square-border-input"
                  density="comfortable"
                  @update:modelValue="handlePriceFilterModeChange"
              ></v-select>
            </v-col>

            <v-col v-if="priceFilterMode === 'single'" cols="12" md="4">
              <v-text-field
                  v-model="singlePrice"
                  type="number"
                  min="0"
                  step="0.01"
                  clearable
                  :clear-icon="singlePrice ? 'mdi-close-circle' : null"
                  hide-details
                  label="Price"
                  placeholder="Enter exact price"
                  variant="outlined"
                  class="custom_input_field_color square-border-input"
                  density="comfortable"
                  @keypress="preventNonNumeric($event, singlePrice)"
              ></v-text-field>
            </v-col>

            <template v-else>
              <v-col cols="12" md="2">
                <v-text-field
                    v-model="priceMin"
                    type="number"
                    min="0"
                    step="0.01"
                    clearable
                    :clear-icon="priceMin ? 'mdi-close-circle' : null"
                    hide-details
                    label="Min Price"
                    placeholder="From"
                    variant="outlined"
                    class="custom_input_field_color square-border-input"
                    density="comfortable"
                    @keypress="preventNonNumeric($event, priceMin)"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="2">
                <v-text-field
                    v-model="priceMax"
                    type="number"
                    min="0"
                    step="0.01"
                    clearable
                    :clear-icon="priceMax ? 'mdi-close-circle' : null"
                    hide-details
                    label="Max Price"
                    placeholder="To"
                    variant="outlined"
                    class="custom_input_field_color square-border-input"
                    density="comfortable"
                    @keypress="preventNonNumeric($event, priceMax)"
                ></v-text-field>
              </v-col>
            </template>
          </v-row>

          <v-divider></v-divider>

          <v-data-table density="comfortable"
                        v-model:page="page" :headers="headers" :loading="loading"
                        :items="filteredItems" :items-per-page="itemsPerPage" class="custom_table_normal"
                        @page="fetchProducts" @page-count="totalPages = $event">

            <template v-slot:[`item.product_title`]="{ item }">
              <div class="product-column">
                <v-row>
                  <v-col cols="5">
                    <img
                        v-if="item.product_image && item.product_image.length > 0"
                        :src="`${imageURL}/${item.product_image[0].image_url}`"
                        aspect-ratio="1" class="product_image mt-2 mb-1"
                        @click="selectImage(`${imageURL}/${item.product_image[0].image_url}`)"
                    />
                  </v-col>

                  <v-col class="d-flex align-center" cols="7">
                    <span class="product-title">{{ item.product_title }}</span>
                  </v-col>
                </v-row>
              </div>
            </template>

            <template v-slot:[`item.price`]="{ item }">
              <div v-if="item.discount_rate && item.discount_rate > 0">
                <div style="text-decoration: line-through; color: #888; font-size: 13px;">
                  LKR. {{ parseFloat(item.price).toFixed(2) }}
                </div>
                <div style="color: #BB0000; font-weight: bold; font-size: 15px;">
                  LKR. {{ calculateDiscountedPrice(item.price, item.discount_rate) }}
                </div>
                <v-chip size="x-small" color="red" variant="flat" class="mt-1 custom-square-card">
                  {{ item.discount_rate }}% Off
                </v-chip>
              </div>
              <div v-else style="font-weight: bold; font-size: 15px;">
                LKR. {{ parseFloat(item.price).toFixed(2) }}
              </div>
            </template>

            <template v-slot:[`item.available_stock`]="{ item }">
              <div class="product-column">
                <v-row>
                  <v-col cols="12">
                    <span>{{ item.available_stock }}</span>
                    <span class="ml-2">{{ item.unit || '' }}</span>
                  </v-col>
                </v-row>
              </div>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-menu transition="slide-x-transition" id="app_product_list">
                <template v-slot:activator="{ props }">
                  <v-btn style="background-color: #800080; color: white;" variant="flat" size="large" class="custom-square-card" v-bind="props">
                    ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list class="custom-square-card">
                  <v-list-item v-if="permissions.read" @click="viewItem(item)">
                    <v-list-item-title class="custom_font_color_view">VIEW</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="permissions.write" @click="editItem(item)">
                    <v-list-item-title class="custom_font_color_edit">EDIT</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                    <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

          </v-data-table>
        </v-card-text>
      </v-card>


      <v-dialog v-model="view_product_dialog" fullscreen id="app_product_list">
        <v-card flat class="custom-square-card">
          <v-toolbar style="border-radius: 0px !important;"
                     class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')"
                     @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-btn
                variant="flat"
                class="custom-square-card"
                style="background-color: #800080; color: white;"
                @click="view_product_dialog = false"
              >
                CLOSE
              </v-btn>
          </v-toolbar>

          <v-row class="mt-15  custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box custom-square-card" border="sm opacity-1">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">PRODUCTS DETAILS</v-card-title>
                </template>
              </v-card>

              <v-card class="pa-3 mx-6 custom_card_box mt-4 custom-square-card" border="sm opacity-1">
                <v-row class="ma-0 mb-2">
                  <v-col cols="12" xs="12" sm="9" md="9" lg="9">
                    <v-row>
                      <v-col cols="12" xs="12" sm="3" md="2" lg="2">
                        <v-img :src="selectedImage ? selectedImage : ''" aspect-ratio="1"
                               class="product_image_view custom-square-card"></v-img>
                      </v-col>
                      <v-col cols="12" xs="12" sm="9" md="10" lg="10">
                        <p class="font-weight-bold custom_page_component_main_title">{{ product.product_title }}</p>

                        <div class="d-flex align-center">
                          <p
                              v-if="!product.discount_rate || product.discount_rate === 0 || product.discount_rate === '0.00'"
                              style="color: #BB0000 !important;"
                              class="font-weight-bold custom_page_component_main_title">
                            LKR. {{ product.price }}
                          </p>

                          <template v-else>
                            <p
                                style="color: #BB0000 !important;"
                                class="font-weight-bold custom_page_component_main_title text-decoration-line-through">
                              LKR. {{ product.price }}
                            </p>
                            <p class="font-weight-medium text-caption ml-4 mt-1">&nbsp;&nbsp;
                              Rs. {{ oldPrice }} &nbsp;&nbsp;
                            </p>
                            <p
                                style="color: #BB0000 !important;"
                                class="font-weight-bold text-caption">&nbsp;&nbsp;
                              {{ product.discount_rate }}%
                            </p>
                          </template>
                        </div>

                        <h4 class="d-flex align-center mt-1">
                          <p class="font-weight-bold custom_page_main_sub_title">STOCK</p>
                          <p
                              style="color: #BB0000 !important;"
                              class="font-weight-bold custom_page_main_sub_title">
                            &nbsp;&nbsp; {{ product.available_stock }} {{ product.unit || '' }}
                          </p>
                        </h4>

                        <v-row class="mt-1">
                          <v-col v-for="(image, index) in product.product_image" :key="index" cols="1">
                            <v-img
                                :src="`${imageURL}/${image.image_url}`"
                                aspect-ratio="1"
                                class="custom_thumbnail_image custom-square-card"
                                @click="selectImage(`${imageURL}/${image.image_url}`)"
                            ></v-img>
                          </v-col>
                        </v-row>
                      </v-col>

                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                      <v-btn
                          v-if="permissions.write" class="mr-3 custom_edit_btn custom-square-card"
                          icon size="small"
                          variant="outlined" @click="editItem(product)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                        <v-tooltip activator="parent" location="top">Edit</v-tooltip>
                      </v-btn>

                      <v-btn
                          v-if="permissions.delete" class="custom_delete_btn custom-square-card" icon
                          size="small" variant="outlined" @click="confirmDelete(product)"
                      >
                        <v-icon>mdi-trash-can</v-icon>
                        <v-tooltip activator="parent" location="top">Delete</v-tooltip>
                      </v-btn>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>

                <v-row class="mb-2">
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-text-field
                        v-model="product.product_title" density="comfortable"
                        class="px-3 custom_input_field_class_view custom_input_field_color square-border-input" label="Product Name"
                        readonly variant="outlined">
                    </v-text-field>

                    <v-text-field
                        v-model="product.main_category"
                        class="px-3 custom_input_field_class_view  custom_input_field_color square-border-input"
                        label="Main Category" readonly variant="outlined" density="comfortable"
                    ></v-text-field>
                    <v-text-field
                        v-model="product.sub_category"
                        class="px-3 custom_input_field_class_view  custom_input_field_color square-border-input" label="Sub Category"
                        readonly variant="outlined" density="comfortable"
                    ></v-text-field>
                    <v-text-field
                        v-model="product.price" class="px-3 custom_input_field_class_view  custom_input_field_color square-border-input"
                        label="Unit Price" readonly
                        variant="outlined" density="comfortable"
                    ></v-text-field>

                    <div class="px-3">
                      <p class="custom_page_main_sub_title">Product Description</p>
                      <v-divider class="mt-3 mb-4"></v-divider>
                      <v-card color="#F7F7F7" flat border="sm opacity-1" outlined density="comfortable" class="custom-square-card">
                        <v-card-text>
                          <div v-html="getSanitizedHTML(product.product_desc)" class=" ml-3 ql-container ql-snow"></div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-text-field
                        v-model="product.unit" class="px-3 custom_input_field_class_view custom_input_field_color square-border-input"
                        label="Unit" readonly
                        variant="outlined" density="comfortable"
                    ></v-text-field>
                    <v-text-field
                        v-model="product.size" class="px-3 custom_input_field_class_view custom_input_field_color square-border-input"
                        label="Size/Number of Units" readonly variant="outlined" density="comfortable"
                    ></v-text-field>
                    <v-text-field
                        v-model="product.color" class="px-3 custom_input_field_class_view custom_input_field_color square-border-input"
                        label="Color" readonly
                        variant="outlined" density="comfortable"
                    ></v-text-field>
                    <v-text-field
                        v-model="product.available_stock"
                        class="px-3 custom_input_field_class_view custom_input_field_color square-border-input"
                        label="Available Stock (Quantity)" readonly
                        variant="outlined" density="comfortable"
                    ></v-text-field>
                    <v-text-field
                        v-if="product.discount_rate !== null"
                        v-model="product.discount_rate"
                        :value="formattedDiscountRate"
                        class="px-3 custom_input_field_class_view custom_input_field_color square-border-input"
                        label="Discount Rate"
                        readonly
                        variant="outlined"
                        density="comfortable"
                    />

                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      
      <v-dialog v-model="edit_product_dialog" fullscreen id="app_product_list">
        <v-card flat class="custom-square-card">
          <v-toolbar style="border-radius: 0px !important;"
                     class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')"
                     @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-btn
                variant="flat"
                class="custom-square-card"
                style="background-color: #800080; color: white;"
                @click="clesoDialog"
              >
                CLOSE
              </v-btn>
          </v-toolbar>

          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box custom-square-card" border="sm opacity-1">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">UPDATE PRODUCTS</v-card-title>
                </template>
              </v-card>

              <v-card class="pa-3 mx-6 custom_card_box mt-4 custom-square-card" border="sm opacity-1">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="9" md="9" lg="9">
                    <v-row>
                      <v-col cols="12" xs="12" sm="3" md="2" lg="2">
                        <v-img :src="selectedImage ? selectedImage : ''" aspect-ratio="1"
                               class="product_image_view custom-square-card"></v-img>
                      </v-col>
                      <v-col cols="12" xs="12" sm="9" md="10" lg="10">
                        <p class="font-weight-bold custom_page_component_main_title">{{ product.product_title }}</p>
                        <div class="d-flex align-center">
                          <p
                              v-if="!product.discount_rate || product.discount_rate === 0 || product.discount_rate === '0.00'"
                              style="color: #BB0000 !important;"
                              class="font-weight-bold custom_page_component_main_title">
                            LKR. {{ product.price }}
                          </p>
                          <template v-else>
                            <p
                                style="color: #BB0000 !important;"
                                class="font-weight-bold custom_page_component_main_title text-decoration-line-through">
                              LKR. {{ product.price }}
                            </p>
                            <p class="font-weight-medium text-caption ml-4 mt-1">&nbsp;&nbsp;
                              Rs. {{ oldPrice }} &nbsp;&nbsp;
                            </p>
                            <p
                                style="color: #BB0000 !important;"
                                class="font-weight-bold text-caption">&nbsp;&nbsp;
                              {{ product.discount_rate }}%
                            </p>
                          </template>
                        </div>
                        <h4 class="d-flex align-center mt-1">
                          <p class="font-weight-bold custom_page_main_sub_title">STOCK</p>
                          <p style="color: #BB0000 !important;" class="font-weight-bold custom_page_main_sub_title">
                            &nbsp;&nbsp; {{ product.available_stock }} {{ product.unit || '' }}
                          </p>
                        </h4>
                        <v-row class="mt-1">
                          <v-col v-for="(image, index) in product.product_image" :key="index" cols="1">
                            <v-img
                                :src="`${imageURL}/${image.image_url}`"
                                aspect-ratio="1"
                                class="custom_thumbnail_image custom-square-card"
                                @click="selectImage(`${imageURL}/${image.image_url}`)"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-alert v-if="isProductDisabled" type="error"
                                   class="font-weight-bold custom_page_component_main_title custom-square-card mt-2" border="left"
                                   colored-border>
                            The product is already sold, so you cannot edit the details.
                          </v-alert>
                        </v-row>

                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                        <v-row class="text-right mt-3 mr-3">
                          <v-spacer></v-spacer>
                            <v-btn
                              size="large"
                              variant="flat"
                              class="custom-square-card"
                              style="background-color: #800080; color: white;"
                              @click="updateProduct"
                              :disabled="isProductDisabled || updateLoading"
                              :loading="updateLoading"
                            >
                              UPDATE PRODUCT
                            </v-btn>
                        </v-row>

                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-text-field
                        v-model="product.product_title" :rules="[v => !!v || 'Product name is required']"
                        class="custom_input_field_color square-border-input" label="Product Name *" required variant="outlined"
                        density="comfortable"
                        :readonly="isProductDisabled"
                    >
                    </v-text-field>

                    <v-autocomplete
                        v-model="productMainCatagary"
                        :clearable="!isProductDisabled && productMainCatagary !== null && productMainCatagary !== ''"
                        :items="mainCategories" :rules="[v => !!v || 'Main category is required']"
                        class="mt-2 custom_input_field_color square-border-input" item-title="name" item-value="name"
                        label="Main Category *" placeholder="Select main category" required variant="outlined"
                        @update:modelValue="fetchSubCategoriesForEdit" density="comfortable" :readonly="isProductDisabled"
                    ></v-autocomplete>

                    <v-autocomplete
                        v-model="product.sub_category" :items="subCategories" :loading="productLoading"
                        :rules="[v => !!v || 'Sub category is required']"
                        class="mt-2 custom_input_field_color square-border-input" item-title="sub_category_name"
                        item-value="sub_category_name" label="Sub Category *" required
                        variant="outlined" density="comfortable" :readonly="isProductDisabled"
                    ></v-autocomplete>

                    <v-text-field
                        v-model="product.price" :rules="[v => !isNaN(Number(v)) || 'Price must be a number']"
                        class="mt-2 custom_input_field_color square-border-input"
                        label="Unit Price *" required variant="outlined" density="comfortable"
                        :readonly="isProductDisabled"
                    ></v-text-field>

                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <p class="custom_page_main_sub_title" style="opacity: 0.6">Product Description </p>
                        <v-card class="mt-5 custom-square-card" elevation="1" border="sm opacity-1" max-height="355"
                                min-height="355">
                          <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode"/>
                          <v-divider></v-divider>
                          <Editor :readonly="isProductDisabled" v-model="product.product_desc"
                                  :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated"/>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-autocomplete
                        v-model="product.unit" :items="units" class="custom_input_field_color square-border-input" 
                        item-title="Unit" item-value="name" label="Unit" required
                        variant="outlined" density="comfortable"
                        :readonly="isProductDisabled"
                    >
                      <template v-slot:selection="{ item }">
                        {{ item.props.title || item.raw.Unit }}
                      </template>
                      <template v-slot:item="{ item, props }">
                        <v-list-item v-bind="props" :title="item.raw.Unit" :value="item.raw.name">
                          <template v-slot:prepend>
                            <v-icon>mdi-cube-outline</v-icon>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    
                    <v-text-field
                        v-model="product.size" class="mt-2 custom_input_field_color square-border-input" label="Size / Number of Units"
                        variant="outlined" density="comfortable"
                        :readonly="isProductDisabled"
                    ></v-text-field>

                    <v-divider class="mb-6 mt-5"></v-divider>

                    <v-chip size="small" class="custom-square-card">Previous Color: {{ product.color }}</v-chip>
                    <br>
                    <v-chip size="small" class="mt-2 custom-square-card" v-if="changeColor">Selected Color: {{
                        getColorName(changeColor)
                      }}
                    </v-chip>

                    <v-divider class="mb-6 mt-5"></v-divider>

                    <v-text-field
                        class="mt-3 custom_input_field_color square-border-input"
                        v-model="changeColor"
                        density="comfortable"
                        label="Select Color"
                        variant="outlined"
                        :readonly="isProductDisabled"
                        @click="dialog = true"
                    />

                    <v-dialog v-model="dialog" max-width="350px" id="app_product_list">
                      <v-card class="custom-square-card">
                        <div class="pa-4">
                          <v-card color="#F0F0F0" flat class="custom-square-card">
                            <template v-slot:prepend>
                              <v-card-title class="text-subtitle-1 font-weight-bold">SET COLOR CODE</v-card-title>
                            </template>
                            <v-spacer></v-spacer>
                            <template v-slot:append>
                              <v-btn @click="dialog = false" icon="mdi-close" size="x-small"></v-btn>
                            </template>
                          </v-card>

                          <v-text-field
                              v-model="changeColor"
                              class="mt-4 custom_input_field_color square-border-input"
                              label="Color Code"
                              density="comfortable"
                              placeholder="Type your color code here"
                              variant="outlined"
                          ></v-text-field>

                          <v-color-picker
                              width="318px"
                              v-model="changeColor"
                              v-model:mode="mode"
                          ></v-color-picker>

                          <v-divider class="mt-3"></v-divider>

                          <div class="float-end mt-4">
                            <v-btn size="large" class="custom_btn_primary custom-square-card" style="background-color: #800080; color: white;" @click="dialog = false">Done</v-btn>
                          </div>
                        </div>
                      </v-card>
                    </v-dialog>


                    <v-text-field
                        v-model="product.available_stock"
                        :rules="[v => !isNaN(Number(v)) || 'Available stock required and must be a number']"
                        class="mt-2 custom_input_field_color square-border-input"
                        label="Available Stock (Quantity) *" required density="comfortable"
                        variant="outlined"
                    ></v-text-field>

                    <v-text-field v-model="product.discount_rate"
                                  :rules="[v => !isNaN(Number(v)) || 'Discount rate must be a number', v => Number(v) >= 0 || 'Discount rate must be 0 or higher', v => Number(v) < 100 || 'Discount rate must be less than 100']"
                                  class="mt-2 custom_input_field_color square-border-input" label="Discount Rate *" variant="outlined"
                                  density="comfortable"
                    ></v-text-field>

                    <v-card flat class="custom-square-card">
                      <p class="custom_page_main_sub_title mb-4" :style="imageError ? 'color: #BB0000 !important; opacity: 1;' : 'opacity: 0.6;'">
                        Product Images * <span class="text-caption text-grey ml-2">({{ previewImages.length }} / 5 images)</span>
                      </p>

                      <div class="image-upload-zone custom-square-card" :class="{ 'has-images': previewImages.length > 0, 'border-error': imageError }" @click="triggerFileInput" @drop.prevent="onDrop" @dragover.prevent="onDragOver">
                        <input ref="fileInput" accept="image/*" class="hidden-file-input" multiple type="file" @change="onFileChange"/>

                        <div v-if="previewImages.length === 0" class="text-center pa-10">
                          <v-icon size="48" color="grey-lighten-1">mdi-image-plus</v-icon>
                          <p class="mt-2 text-grey">Drag your photo here OR <span style="color:#800080;" class="font-weight-bold">Browse from device</span></p>
                        </div>

                        <v-row v-else class="pa-2 ma-0">
                          <v-col v-for="(image, index) in previewImages" :key="index" cols="4" class="position-relative">
                            <v-img :alt="'Image ' + (index + 1)" :src="image" aspect-ratio="1" cover class="border custom-square-card">
                              <div class="delete-overlay custom-square-card">
                                <v-btn icon="mdi-delete" color="red" size="small" @click.stop="removeImage(index)"></v-btn>
                              </div>
                            </v-img>
                          </v-col>
                          <v-col v-if="previewImages.length < 5" cols="4" class="d-flex align-center justify-center">
                             <v-btn icon="mdi-plus" variant="outlined" color="grey" class="custom-square-card"></v-btn>
                          </v-col>
                        </v-row>
                      </div>
                      <p v-if="imageError" class="text-caption mt-1" style="color: #BB0000;">Product image is required</p>
                      <p v-else-if="previewImages.length >= 5" class="text-caption mt-1" style="color: #BB0000;">Maximum 5 images allowed</p>
                    </v-card>

                  </v-col>
                </v-row>
              </v-card>

            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      
      <v-dialog v-model="delete_product_dialog" max-height="500" max-width="500" persistent id="app_product_list">
        <v-card class="custom-square-card">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat class="custom-square-card">
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE PRODUCT</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="delete_product_dialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3 custom-square-card">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this product?
                </v-card-title>


                <div style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  {{
                    salesProductList.length > 0
                        ? "This product cannot be deleted because they have associated data in the following tables. Please remove the associations first."
                        : "This product will be deleted immediately. Once deleted, it can no longer be used for any purpose."
                  }}
                </div>

                <v-divider class="mt-4"></v-divider>

                <v-timeline align="start" density="compact">
                  <v-timeline-item
                      v-for="(sale, index) in salesProductList"
                      :key="sale.id"
                      dot-color="#05146F"
                  >
                  <template v-slot:opposite></template>
                  <div>
                    <div class="text-h6">Related Sale {{ index + 1 }}</div>
                    <p><strong>Sale ID:</strong> {{ sale.sale_id }}</p>
                    <p><strong>Sales Amount:</strong> {{ sale.sales_amount }}</p>
                    <p><strong>Sale Date:</strong> {{ formatDate(sale.created_at) }}</p>
                  </div>
                  </v-timeline-item>
                </v-timeline>


                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4">
                  <v-btn
                    style="background-color: red; color: white;"
                    class="custom-square-card"
                    :disabled="salesProductList.length > 0"
                    @click="deleteItem"
                  >
                    DELETE
                  </v-btn>
                  <v-btn class="ml-3 custom_btn_secondary custom-square-card" @click="delete_product_dialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight"
                  :top="snackAlert.snackBarTop" location="top right" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from "xlsx";
import ntc from 'ntc';
import {getPermissions} from "@/plugins/permissions";
import DOMPurify from 'dompurify';


import '@wangeditor/editor/dist/css/style.css';
import {i18nChangeLanguage} from '@wangeditor/editor'

i18nChangeLanguage('en')
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import {onBeforeUnmount, ref, shallowRef, onMounted} from 'vue'

export default {
  components: {
    Editor,
    Toolbar,
  },

  setup() {
    const editorRef = shallowRef()

    const valueHtml = ref('<p></p>')

    onMounted(() => {
      setTimeout(() => {
        valueHtml.value = '<p></p>'
      }, 1500)
    })

    const toolbarConfig = {toolbarKeys: ['bold', 'italic', 'underline', 'through']}
    const editorConfig = {placeholder: 'Type here...'}

    onBeforeUnmount(() => {
      const editor = editorRef.value
      if (editor == null) return
      editor.destroy()
    })

    const handleCreated = (editor) => {
      editorRef.value = editor
    }

    return {
      editorRef,
      mode: 'simple',
      valueHtml,
      toolbarConfig,
      editorConfig,
      handleCreated
    };
  },

  name: 'ProductsList',

  data() {
    return {

      salesProductList: [],
      changeColor: "",
      isProductDisabled: false,
      updateLoading: false,
      dataDescription: '',
      formatting: [],
      imageURL: "",
      showColorPicker: false,
      selectedColor: '#000',
      alignment: '',
      imageError: false,
      textareaStyles: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        textDecoration: 'none',
        color: '#000',
        textAlign: 'left',
      },

      loading: false,
      form: {images: []},
      search: '',
      selectedMainCategory: null,
      selectedSubCategory: [],
      priceFilterMode: 'single',
      singlePrice: null,
      priceMin: null,
      priceMax: null,
      priceFilterModes: [
        {title: 'Single Price', value: 'single'},
        {title: 'Price Range', value: 'range'},
      ],


      itemsPerPage: 10,
      page: 1,
      totalPages: 0,

      headers: [
        {text: 'PRODUCT NAME', value: 'product_title', title: 'PRODUCT NAME', sortable: true},
        {text: 'MAIN CATEGORY', value: 'main_category', title: 'MAIN CATEGORY', sortable: true},
        {text: 'SUB CATEGORY', value: 'sub_category', title: 'SUB CATEGORY', sortable: true},
        {text: 'PRICE', value: 'price', title: 'PRICE(LKR)', sortable: true},
        {text: 'STOCK AVAILABILITY', value: 'available_stock', title: 'STOCK AVAILABILITY', sortable: true},
        {text: 'ACTION', value: 'action', sortable: false, title: 'ACTION'},
      ],

      delete_product_dialog: false,
      view_product_dialog: false,
      productMainCatagary: '',
      sanitizedDescription: '',

      edit_product_dialog: false,
      typeDescription: "",
      productLoading: false,
      selectedProductId: null,
      product: {},

      numericRule: value => !isNaN(parseFloat(value)) || 'Price must be a number',
      item: [],
      units: [
        {Unit: 'Grams (g)', name: 'g'},
        {Unit: 'Kilograms (kg)', name: 'kg'},
        {Unit: 'Pound (lb)', name: 'lb'},
        {Unit: 'Liter (L)', name: 'L'},
        {Unit: 'Milliliter (mL)', name: 'ml'},
        {Unit: 'Gallon', name: 'Gallon'},
        {Unit: 'Meters (m)', name: 'm'},
        {Unit: 'Centimeters (cm)', name: 'cm'},
        {Unit: 'Piece (pcs)', name: 'pcs'},
        {Unit: 'Box', name: 'Box'},
        {Unit: 'Packet (pkt)', name: 'pkt'},
        {Unit: 'Set', name: 'Set'},
        {Unit: 'Dozen (dz)', name: 'dz'},
        {Unit: 'Pair', name: 'Pair'},
        {Unit: 'Roll', name: 'Roll'},
        {Unit: 'Bundle', name: 'Bundle'},
        {Unit: 'Unit', name: 'Unit'},
        {Unit: 'Case', name: 'Case'},
        {Unit: 'Carton', name: 'Carton'},
        {Unit: 'Tonne (ton)', name: 'ton'},
        {Unit: 'Barrel', name: 'Barrel'},
        {Unit: 'Can', name: 'Can'}
      ],

      mainCategories: [],
      subCategories: [],
      items: [],
      product_image: [],
      previewImages: [],
      selectedImage: '',

      snackAlert: {
        snackbar: false,
        snackColor: "",
        snackMessage: "",
        snackBarRight: false,
        snackBarTop: true,
      },
      productcheck: null,
      dialog: false,
      modes: ['RGB', 'HSL'],
      removedImages: [],
      permissions: { read: false, write: false, delete: false },
    };
  },

  created() {
    this.imageURL = process.env.VUE_APP_IMAGE_URL;
    this.fetchProducts();
    this.fetchMainCategories();
  },

  methods: {

    preventNonNumeric(event, value) {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode === 101 || charCode === 69 || charCode === 43 || charCode === 45) {
        event.preventDefault();
        return false;
      }
      if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      if (charCode === 46 && value && value.toString().includes('.')) {
        event.preventDefault();
        return false;
      }
      return true;
    },

    getSanitizedHTML(html) {
      return DOMPurify.sanitize(html);
    },
    convertToPlainText(html) {
      const sanitizedHTML = this.getSanitizedHTML(html);
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sanitizedHTML;
      return tempDiv.textContent || tempDiv.innerText || '';
    },
    applyFormat(format) {
      if (format === 'italic') {
        this.textareaStyles.fontStyle =
            this.textareaStyles.fontStyle === 'italic' ? 'normal' : 'italic';
      } else if (format === 'bold') {
        this.textareaStyles.fontWeight =
            this.textareaStyles.fontWeight === 'bold' ? 'normal' : 'bold';
      } else if (format === 'underline') {
        this.textareaStyles.textDecoration =
            this.textareaStyles.textDecoration === 'underline'
                ? 'none'
                : 'underline';
      } else if (format === 'color') {
        this.textareaStyles.color = this.selectedColor;
      }
    },

    setAlignment(align) {
      this.textareaStyles.textAlign = align;
    },

    getColorName(hex) {
      const color = ntc.name(hex);
      return color[1];
    },

    calculateDiscountedPrice(price, discountRate) {
      const p = parseFloat(price);
      const d = parseFloat(discountRate);
      if (isNaN(p) || isNaN(d) || d <= 0) return p.toFixed(2);
      const discounted = p - (p * d / 100);
      return discounted.toFixed(2);
    },

    sizeValidation(value) {
      const sizePattern = /^\d+(\.\d+)?\s*(cm|centimeter|centimeters|mm|millimeter|millimeters|in|inches|m|meter|meters|ft|feet|other)$/i;
      return sizePattern.test(value.trim());
    },

    exportExcel() {
      const tableData = this.filteredItems.map((item) => ({

        'Product Name': item.product_title,
        'Main Category': item.main_category,
        'Sub Category': item.sub_category,
        'Price': item.price,
        'Stock Availability': item.available_stock,
        'Color': item.color,
        'Discount Rate': `${item.discount_rate}%`,
        'Size': item.size,
        'Unit': item.unit,
      }));

      const worksheet = XLSX.utils.json_to_sheet(tableData);

      const columnWidths = [
        {wpx: 50},
        {wpx: 150},
        {wpx: 120},
        {wpx: 120},
        {wpx: 80},
        {wpx: 100},
        {wpx: 80},
        {wpx: 110},
        {wpx: 80},
        {wpx: 70},
      ];
      worksheet['!cols'] = columnWidths;

      Object.keys(worksheet).forEach(cell => {
        if (cell.startsWith('A1')) {
          worksheet[cell].s = {
            font: {bold: true, color: {rgb: "FFFFFF"}},
            fill: {fgColor: {rgb: "1F4E78"}},
            alignment: {horizontal: "center"},
          };
        }
      });

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Products List');

      XLSX.writeFile(workbook, 'products_list.xlsx');
      const fileName = 'products_list.xlsx';
      const file_type = 'excel';
      this.logDocumentDownload(fileName, file_type);
    },


    exportPDF() {
      const doc = new jsPDF();

      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      doc.text('Product List', 14, 20);

      doc.setFontSize(11);
      doc.setFont("helvetica", "normal");
      doc.text('A comprehensive list of product data', 14, 28);

      const tableData = this.filteredItems.map((item, index) => [
        index + 1,
        item.product_title,
        item.main_category,
        item.sub_category,
        item.price,
        item.available_stock,
        item.color,
        `${item.discount_rate}%`,
        item.size,
        item.unit,
      ]);

      const tableColumns = [
        {header: 'NO', dataKey: 'index'},
        {header: 'Product Name', dataKey: 'product_title'},
        {header: 'Main Category', dataKey: 'main_category'},
        {header: 'Sub Category', dataKey: 'sub_category'},
        {header: 'Unit Price', dataKey: 'price'},
        {header: 'Stock', dataKey: 'available_stock'},
        {header: 'Color', dataKey: 'color'},
        {header: 'Discount Rate', dataKey: 'discount_rate'},
        {header: 'Number Of Units', dataKey: 'size'},
        {header: 'Unit', dataKey: 'unit'},
      ];

      doc.autoTable({
        head: [tableColumns.map(col => col.header)],
        body: tableData,
        startY: 35,
        startX: 5,
        headStyles: {fillColor: [41, 128, 185], textColor: [255, 255, 255], fontSize: 8},
        bodyStyles: {fontSize: 8},
        columnStyles: {
          0: {cellWidth: 10},
          1: {cellWidth: 30},
          2: {cellWidth: 25},
          3: {cellWidth: 25},
          4: {cellWidth: 15},
          5: {cellWidth: 20},
          6: {cellWidth: 15},
          7: {cellWidth: 20},
          8: {cellWidth: 15},
          9: {cellWidth: 15},
        },
        styles: {cellPadding: 3, overflow: 'linebreak'},
        theme: 'striped',
        didDrawPage: function (data) {
          let pageSize = doc.internal.pageSize;
          let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text('Page ' + doc.internal.getNumberOfPages(), data.settings.margin.left, pageHeight - 10);
          doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, doc.internal.pageSize.height - 15);
        },
      });

      doc.save('Product_List.pdf');
      const fileName = 'Product_List.pdf';
      const file_type = 'pdf';
      this.logDocumentDownload(fileName, file_type);
    },

    async logDocumentDownload(fileName, file_type) {
      console.log(fileName);
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        if (!userId) {
          throw new Error('User ID not found');
        }

        const response = await axios.post(`/api/log-document-download`, {
          user_id: userId,
          file_type: file_type,
          file_name: fileName,
          entity_area: 'Product Management',

          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.status !== 200) {
          throw new Error('Failed to log download');
        }

        console.log('Download logged successfully');
      } catch (error) {
        console.error('Error logging download:', error);
      }
    },


    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    fetchMainCategories() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      axios.post('/api/mainProduct', {
        userId: userId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
          .then(response => {
            let sample = response.data.data;
            this.mainCategories = sample.map(item => {
              return {
                id: item.id,
                name: item.main_category
              };
            });
            console.log('Main categories:', this.mainCategories);
          })
          .catch(error => {
            console.error('Error fetching main categories:', error);
          });
    },

    clesoDialog() {
      this.isProductDisabled = false;
      this.edit_product_dialog = false;
      this.selectedMainCategory = null;
      this.productMainCatagary = null;
      this.changeColor = '';
      this.removedImages = [];
      this.form.images = [];
      this.subCategories = [];
    },

    fetchSubCategoriesForEdit() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');

      if (!this.productMainCatagary) {
        console.log('No main category selected');
        return;
      }

      this.productLoading = true;
      
      const selectedCategory = this.mainCategories.find(cat => cat.name === this.productMainCatagary);
      const categoryId = selectedCategory ? selectedCategory.id : this.productMainCatagary;

      console.log('Fetching subcategories for:', this.productMainCatagary, 'ID:', categoryId);

      axios.post(`/api/subcatagoryProduct`,
          {
            userId: userId,
            mainCatagoryId: categoryId,
          },
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          })
          .then(response => {
            this.subCategories = response.data.data;
            console.log('Subcategories loaded:', this.subCategories);
            this.productLoading = false;
          })
          .catch(error => {
            console.error('Error fetching sub categories:', error);
            this.productLoading = false;
          });
    },

    getCategoryName(categoryId) {
      const category = this.mainCategories.find(cat => cat.id === categoryId);
      return category ? category.name : 'Unknown';
    },

    showSnackAlert(type, message) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackColor = type;
      this.snackAlert.snackMessage = message;
    },

    normalizePrice(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }

      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    },

    handlePriceFilterModeChange() {
      this.singlePrice = null;
      this.priceMin = null;
      this.priceMax = null;
    },

    async updateProduct() {
      if (!this.product.product_title) {
        this.showSnackAlert('error', 'Product title is required.');
        return;
      }

      if (!this.productMainCatagary) {
        this.showSnackAlert('error', 'Main category is required.');
        return;
      }

      if (!this.product.sub_category) {
        this.showSnackAlert('error', 'Sub-category is required.');
        return;
      }

      if (!this.product.price || isNaN(this.product.price) || this.product.price <= 0) {
        this.showSnackAlert('error', 'Valid price is required.');
        return;
      }

      if (this.product.discount_rate === null || this.product.discount_rate < 0) {
        this.product.discount_rate = 0;
      }

      if (!this.product.available_stock || isNaN(this.product.available_stock) || this.product.available_stock < 0) {
        this.showSnackAlert('error', 'Available stock must be 0 or greater.');
        return;
      }

      if (this.previewImages.length === 0) {
        this.imageError = true;
        this.showSnackAlert('error', 'At least one product image is required.');
        return;
      }

      if (!this.product.unit) {
        this.product.unit = "Unit";
      }

      if (!this.product.size) {
        this.product.size = "";
      }

      this.updateLoading = true;

      const formData = new FormData();
      formData.append('productId', this.product.id);
      formData.append('productTitle', this.product.product_title);
      formData.append('productDescription', this.product.product_desc || '');
      formData.append('mainCatagory', this.productMainCatagary);
      formData.append('subCatagory', this.product.sub_category);
      formData.append('unit', this.product.unit);
      formData.append('size', this.product.size);

      if (this.changeColor) {
        const colorName = this.getColorName(this.changeColor);
        formData.append('color', colorName);
      } else {
        formData.append('color', this.product.color);
      }

      formData.append('price', this.product.price);
      formData.append('discountRate', this.product.discount_rate);
      formData.append('availableStaock', this.product.available_stock);
      formData.append('userId', localStorage.getItem('userId'));

      try {
        const base64Images = await Promise.all(
            this.form.images.map(file => this.convertToBase64(file))
        );

        const previousImages = (this.product.product_image || [])
            .filter(img => !this.removedImages.includes(img.image_url))
            .map(img => ({image: img.image_url}));

        const allImages = [
            ...previousImages,
            ...base64Images.map(image => ({image}))
        ];

        const imagesJson = JSON.stringify(allImages);
        formData.append('productImage', imagesJson);

        const token = localStorage.getItem('token');
        const response = await axios.post(`/api/addProduct`, formData, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data.success || response.status === 200 || response.status === 201) {
          this.showSnackAlert('success', 'Product updated successfully');
          setTimeout(() => {
            this.edit_product_dialog = false;
            this.fetchProducts();
            this.clesoDialog();
          }, 1500);
        } else {
          this.showSnackAlert('error', response.data.error || 'Failed to update product');
        }
      } catch (error) {
        console.error('Error updating product:', error);
        this.showSnackAlert('error', error.response?.data?.error || 'Failed to update product. Please try again.');
      } finally {
        this.updateLoading = false;
      }
    },

    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        if (file instanceof Blob || file instanceof File) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
          };
          reader.onerror = error => reject(error);
        } else {
          reject(new Error('Invalid file type'));
        }
      });
    },

    homeReload() {
      window.location.href = '/dashboard';
    },

    fetchProducts() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");
      this.loading = true;
      const formData = new FormData();
      formData.append("userId", userId);

      axios.post('/api/getProductList', formData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
          .then(response => {
            this.items = response.data.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            this.loading = false;
          })
          .catch(error => {
            console.error('Error fetching products:', error);
            this.loading = false;
          });
    },

    addProductsPageRoute() {
      this.$router.push({path: '/add-products'});
    },

    viewItem(item) {
      this.selectedProductId = item.id;
      this.product = {...item}; 

      this.selectedImage = item.product_image && item.product_image.length > 0
          ? `${this.imageURL}/${item.product_image[0].image_url}`
          : '';

      this.view_product_dialog = true;
    },

    editItem(item) {
      this.edit_product_dialog = true;
      this.selectedProductId = item.id;
      this.product = JSON.parse(JSON.stringify(item));
      this.productMainCatagary = item.main_category;
      this.changeColor = '';
      this.imageError = false;

      this.selectedImage = item.product_image && item.product_image.length > 0
          ? `${this.imageURL}/${item.product_image[0].image_url}`
          : '';

      this.previewImages = (item.product_image || []).map(img =>
          `${this.imageURL}/${img.image_url}`
      );

      this.form.images = [];
      this.removedImages = [];

      this.fetchSubCategoriesForEdit();

      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');

      axios.post(`/api/checkProductIsInSlesTable`,
          {
            userId: userId,
            productId: item.id,
          },
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          })
          .then(response => {
            let result = response.data.message;
            if (result === 'hasProduct') {
              this.isProductDisabled = true;
            } else {
              this.isProductDisabled = false;
            }
          })
          .catch(error => {
            console.error('Error checking product associations:', error);
            this.isProductDisabled = false;
          });
    },

    async confirmDelete(item) {
      this.selectedProductId = item.id;
      this.salesProductList = [];

      try {
        const token = localStorage.getItem('token');

        const response = await axios.post(
            `/api/checkProductAssociations/${this.selectedProductId}`,
            {},
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }
        );

        if (response.data.associated_data?.sales_product_list) {
          this.salesProductList = response.data.associated_data.sales_product_list;
        }

        this.delete_product_dialog = true;

      } catch (error) {
        console.error("Error fetching product associations:", error);
        this.delete_product_dialog = true;
      }
    },


    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    deleteItem() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      const ProductID = this.selectedProductId;

      axios.post(`/api/deleteProduct`, {
        userId: userId,
        ProductID: ProductID,
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

          .then(() => {
            this.fetchProducts();
            this.delete_product_dialog = false; 
            this.view_product_dialog = false;
            this.showSnackbar("The Product was successfully deleted.", "success");
          })
          .catch((error) => {
            console.log('Error deleting Product', error);
            this.delete_product_dialog = false;
            this.showSnackbar("Failed to delete product.", "error");
          });
    },

    backPageRoute() {
      this.$router.back();
    },

    selectImage(image) {
      this.selectedImage = image;
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    onFileChange(event) {
      const files = event.target.files;
      this.handleFiles(files);
    },

    onDrop(event) {
      const files = event.dataTransfer.files;
      this.handleFiles(files);
    },

    onDragOver(event) {
      event.preventDefault();
    },

    handleFiles(files) {
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      const fileArray = Array.from(files).filter(file => validImageTypes.includes(file.type));
      const maxImages = 5;
      const remainingSlots = maxImages - this.previewImages.length;

      if (fileArray.length === 0) {
        this.showSnackbar('Only image files are allowed!', 'error');
        return;
      }

      if (remainingSlots <= 0) {
        this.showSnackbar(`You can only upload up to ${maxImages} images.`, "error");
        return;
      }

      const filesToAdd = fileArray.slice(0, remainingSlots);
      
      filesToAdd.forEach(file => {
        this.form.images.push(file);
        this.previewImages.push(URL.createObjectURL(file));
      });
      if (this.previewImages.length > 0) {
        this.imageError = false;
      }
    },

    removeImage(index) {
      let removedImage = this.previewImages[index];
      
      if (removedImage.startsWith(this.imageURL)) {
        const imageUrl = removedImage.replace(this.imageURL + '/', '');
        this.removedImages.push(imageUrl);
      } else {
        let existingCount = this.previewImages.filter(img => img.startsWith(this.imageURL)).length;
        let fileIndex = index - existingCount;
        if (fileIndex >= 0 && fileIndex < this.form.images.length) {
            this.form.images.splice(fileIndex, 1);
        }
      }
      
      this.previewImages.splice(index, 1);
      
      if (this.previewImages.length === 0) {
        this.imageError = true;
      }
    },
  },

  mounted() {
    this.permissions = getPermissions(0, "Module Name");

    if (!this.permissions.read) {
      this.showSnackbar("Access Denied", "error");
      this.$router.push('/dashboard'); 
    }
    console.log("Permissions:", this.permissions);
  },

  computed: {
    uniqueTableSubCategories() {
      const subCatsMap = new Map();
      let sourceItems = this.items;

      if (this.selectedMainCategory) {
        const selectedCatObj = this.mainCategories.find(c => c.id === this.selectedMainCategory || c.name === this.selectedMainCategory);
        const selectedCatName = selectedCatObj ? selectedCatObj.name : this.selectedMainCategory;
        sourceItems = sourceItems.filter(item => item.main_category === selectedCatName);
      }

      sourceItems.forEach(item => {
        const subName = item.sub_category || item.sub_category_name;
        if (subName && !subCatsMap.has(subName)) {
          subCatsMap.set(subName, { sub_category_name: subName });
        }
      });

      return Array.from(subCatsMap.values());
    },

    formattedDiscountRate() {
      return (this.product.discount_rate ?? '0') + '%';
    },
    
    oldPrice() {
      const price = parseFloat(this.product.price);
      const discountRate = parseFloat(this.product.discount_rate);

      if (isNaN(price) || isNaN(discountRate)) {
        return '0.00';
      }

      if (discountRate > 0) {
        const discountAmount = (price * discountRate) / 100;
        const discountedPrice = price - discountAmount;
        return discountedPrice.toFixed(2); 
      }

      return price.toFixed(2);
    },

    filteredItems() {
      return this.items.filter(product => {
        let selectedCatName = null;
        if (this.selectedMainCategory) {
          const selectedCatObj = this.mainCategories.find(c => c.id === this.selectedMainCategory || c.name === this.selectedMainCategory);
          selectedCatName = selectedCatObj ? selectedCatObj.name : this.selectedMainCategory;
        }

        const matchesMainCategory = !selectedCatName || product.main_category === selectedCatName;

        const matchesSubCategory = !this.selectedSubCategory || this.selectedSubCategory.length === 0 ||
            this.selectedSubCategory.includes(product.sub_category);

        const matchesSearch = !this.search ||
            (product.product_title && product.product_title.toLowerCase().includes(this.search.toLowerCase())) ||
            (product.main_category && product.main_category.toLowerCase().includes(this.search.toLowerCase())) ||
            (product.sub_category && product.sub_category.toLowerCase().includes(this.search.toLowerCase())) ||
            (product.price && product.price.toString().toLowerCase().includes(this.search.toLowerCase())) ||
            (product.available_stock && product.available_stock.toString().toLowerCase().includes(this.search.toLowerCase()));

        // Accurate pricing calculation for filtering
        const origPrice = parseFloat(product.price);
        const dRate = parseFloat(product.discount_rate);
        let finalPrice = origPrice;
        
        if (!isNaN(origPrice) && !isNaN(dRate) && dRate > 0) {
          finalPrice = origPrice - (origPrice * dRate / 100);
        }

        let matchesPrice = true;
        
        if (this.priceFilterMode === 'single' && this.singlePrice !== null && this.singlePrice !== '') {
          const searchStr = String(this.singlePrice).trim();
          const origPriceStr = !isNaN(origPrice) ? origPrice.toString() : '';
          const finalPriceStr = !isNaN(finalPrice) ? finalPrice.toString() : '';
          const finalPriceFixedStr = !isNaN(finalPrice) ? finalPrice.toFixed(2).toString() : '';

          matchesPrice = origPriceStr.startsWith(searchStr) || finalPriceStr.startsWith(searchStr) || finalPriceFixedStr.startsWith(searchStr);
        } else if (this.priceFilterMode === 'range') {
          const minPrice = this.normalizePrice(this.priceMin);
          const maxPrice = this.normalizePrice(this.priceMax);
          
          if (minPrice !== null && maxPrice !== null) {
            matchesPrice = !isNaN(finalPrice) && finalPrice >= minPrice && finalPrice <= maxPrice;
          } else if (minPrice !== null) {
            matchesPrice = !isNaN(finalPrice) && finalPrice >= minPrice;
          } else if (maxPrice !== null) {
            matchesPrice = !isNaN(finalPrice) && finalPrice <= maxPrice;
          }
        }

        return matchesMainCategory && matchesSubCategory && matchesSearch && matchesPrice;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@use "../../styles/product_management/products_list.scss" as *;

.image-upload-zone {
  border: 2px dashed #e0e0e0;
  border-radius: 2px;
  min-height: 180px;
  transition: all 0.3s ease;
  cursor: pointer;
  background: #fcfcfc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-upload-zone:hover {
  border-color: #800080;
  background: #faf5fa;
}

.image-upload-zone.border-error {
  border-color: #BB0000 !important;
  background: #fff5f5 !important;
}

.image-upload-zone.has-images {
  display: block;
  min-height: auto;
}

.delete-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: 0.2s;
}

.position-relative:hover .delete-overlay {
  opacity: 1;
}

.custom-square-card {
  border-radius: 2px !important;
}

.square-border-input :deep(.v-field),
.square-border-input :deep(.v-field__outline),
.square-border-input :deep(.v-field__overlay),
.square-border-input :deep(.v-field__outline__start),
.square-border-input :deep(.v-field__outline__end),
.square-border-input :deep(.v-field__outline__notch::before),
.square-border-input :deep(.v-field__outline__notch::after) {
  border-radius: 2px !important;
}
</style>